import i18n from "i18next";
import React from "react";
import ReactDOM from "react-dom";
import { I18nextProvider, initReactI18next } from "react-i18next";
import App from "./App";
import { getLocalStorage, LOCAL_STORAGE_TYPE } from "./common/localStorage";
import "./index.css";
import enTranslation from "./locales/en.json";
import viTranslation from "./locales/vi.json";
import reportWebVitals from "./reportWebVitals";

window.AirflexJS.create(process.env.REACT_APP_JSSDK_KEY, { devmode: process.env.REACT_APP_ENVIRONMENT === "dev" });

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enTranslation },
    vi: { translation: viTranslation },
  },
  lng: getLocalStorage(LOCAL_STORAGE_TYPE.LANGUAGE) || "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

ReactDOM.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
